<app-top-nav></app-top-nav>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-toasts></app-toasts>
